enum ActivityTypes {
    LESSON = "learn",
    PRACTICE = "practice",
    COMPETE = "compete",
    CONCEPT = "concept",
}

export default ActivityTypes;
